import { render, staticRenderFns } from "./Discord.vue?vue&type=template&id=684c1de2&scoped=true"
import script from "./Discord.vue?vue&type=script&lang=js"
export * from "./Discord.vue?vue&type=script&lang=js"
import style0 from "./Discord.vue?vue&type=style&index=0&id=684c1de2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684c1de2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('684c1de2')) {
      api.createRecord('684c1de2', component.options)
    } else {
      api.reload('684c1de2', component.options)
    }
    module.hot.accept("./Discord.vue?vue&type=template&id=684c1de2&scoped=true", function () {
      api.rerender('684c1de2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Discord.vue"
export default component.exports